'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const MemberChart = dynamic(() => import('@/app/reporting/components/MembershipLineChart'), { ssr: false });

export default function MembershipGrowthPanel() {
  const stats = [
    { id: 'mg-total',   label: 'Total Members',    value: '2,841',  color: 'text-foreground' },
    { id: 'mg-new',     label: 'New This Month',   value: '+142',   color: 'text-success' },
    { id: 'mg-churn',   label: 'Churned',          value: '-46',    color: 'text-danger' },
    { id: 'mg-net',     label: 'Net Growth',       value: '+96',    color: 'text-success' },
  ];

  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Membership Growth</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Last 12 months · $229/yr avg value</p>
        </div>
        <div className="text-right">
          <div className="text-xs text-muted-foreground">Annual recurring</div>
          <div className="text-sm font-bold text-success font-tabular">$650,589</div>
        </div>
      </div>
      <div className="px-5 py-4">
        <MemberChart />
        <div className="mt-3 grid grid-cols-4 gap-2 pt-3 border-t border-border">
          {stats?.map((s) => (
            <div key={s?.id} className="text-center">
              <div className={`text-base font-bold font-tabular ${s?.color}`}>{s?.value}</div>
              <div className="text-xs text-muted-foreground">{s?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}